export default __webpack_public_path__ + "static/media/growthcatalyst-card-image-widget.ea2e7663.png";